import { useState } from "react";
import { motion, useAnimation } from "framer-motion";
import Supermanpic from "./slidingImages/Superman.jpg";
import Alien from "./slidingImages/alienOutpost.jpg";

function FadingCarousal() {
  const [images, setImages] = useState([Supermanpic, Alien]);
  const controls = useAnimation();

  const variants = {
    enter: (index) => ({
      opacity: 1,
      transition: {
        duration: 0.5,
        delay: index * 0.2,
      },
    }),
    exit: {
      opacity: 0,
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <motion.div
      initial="exit"
      animate={controls}
      variants={variants}
      className="carousel-container"
    >
      {images.map((imageUrl, index) => (
        <motion.img
          key={index}
          src={imageUrl}
          alt={`Slide ${index + 1}`}
          custom={index}
          variants={variants}
          initial="exit"
          animate={controls}
          exit="exit"
          transition={{
            duration: 0.5,
          }}
        />
      ))}
    </motion.div>
  );
}

export default FadingCarousal;
